import { render } from "./EditWatchList.vue?vue&type=template&id=268f250a&ts=true"
import script from "./EditWatchList.vue?vue&type=script&lang=ts"
export * from "./EditWatchList.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__